var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_31931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_31931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 12V10H11.0001V12H1.00012ZM3.00012 8H3.70012L7.60012 4.1125L6.88762 3.4L3.00012 7.3V8ZM2.00012 9V6.875L7.60012 1.2875C7.69179 1.19583 7.79804 1.125 7.91887 1.075C8.03971 1.025 8.16679 1 8.30012 1C8.43346 1 8.56262 1.025 8.68762 1.075C8.81262 1.125 8.92512 1.2 9.02512 1.3L9.71262 2C9.81262 2.09167 9.88554 2.2 9.93137 2.325C9.97721 2.45 10.0001 2.57917 10.0001 2.7125C10.0001 2.8375 9.97721 2.96042 9.93137 3.08125C9.88554 3.20208 9.81262 3.3125 9.71262 3.4125L4.12512 9H2.00012Z",
    fill: "#1C74D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/editImg.137c99580c7feeb59a9b0b5f5a812d8a.svg";
export { ForwardRef as ReactComponent };